<template>
    <div
        class="date-container"
        style="position: relative;"
    >
        <div style="float: left; width: 46%;">
            <date-picker
                ref="start"
                v-model="start"
                :config="startConfig"
            />
        </div>
        <span style="line-height: 30px;">
            -
        </span>
        <div style="float: right; display: inline-block; width: 46%;">
            <date-picker
                ref="end"
                v-model="end"
                :config="endConfig"
                @dp-change="setMinDate"
            />
        </div>
        <input
            type="hidden"
            :name="inputname"
            :value="value"
        >
    </div>
</template>

<script>
    const icons = {
        time: 'fa fa-clock',
        date: 'fa fa-calendar',
        up: 'fa fa-arrow-up',
        down: 'fa fa-arrow-down',
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-calendar-check',
        clear: 'fa fa-trash-alt',
        close: 'fa fa-times-circle'
    }

    export default {
        name: 'RangePicker',
        props: {
            inputname: {
                type: String,
                default: '',
            },
            range: {
                type: String,
                default: null,
            },
            val: {
                type: String,
                default: '',
            },
        },
        data: function() {
            return { 
                start: null,
                end: null,
                value: ',',
                startConfig: {
                    format: 'DD.MM.YYYY',
                    maxDate: moment().endOf('d'),
                    locale: 'ru',
                    useCurrent: false,
                    icons: icons, 
                },
                endConfig: {
                    format: 'DD.MM.YYYY',
                    maxDate: moment().endOf('d'),
                    locale: 'ru',
                    useCurrent: false,
                    icons: icons, 
                },
            }
        },
        watch: {
            start: function () {
                this.value = (this.start || '') + '-' + (this.end || '');
                this.emitChange(this.value);
            },
            end: function () {
                this.value = (this.start || '') + '-' + (this.end || '');
                this.emitChange(this.value);
            },
        },
        mounted: function() {
            this.value = this.val;
            if (this.range) {
                let rng = this.range.split('-');
                this.start = rng[0] 
                this.end = rng[1] 
            }

        },
        methods: {
            emitChange: function(val) {
                this.$emit('change', val);
            },
            setMinDate: function(val) {
                if (this.start) {
                    if (this.start > this.end) {
                        this.start = this.end;
                    }
                }
                this.startConfig.maxDate = moment(val.date).endOf('d');
            }
        },
    }
</script>
